import { render, staticRenderFns } from "./FourInARow.vue?vue&type=template&id=f4708cc6&scoped=true&"
import script from "./FourInARow.vue?vue&type=script&lang=js&"
export * from "./FourInARow.vue?vue&type=script&lang=js&"
import style0 from "./FourInARow.vue?vue&type=style&index=0&id=f4708cc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4708cc6",
  null
  
)

export default component.exports